var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { title: _vm.title } },
    [
      _c("FormBasicInfo", { ref: "formBasicInfo" }),
      _c("FormTable"),
      _c(
        "div",
        { staticClass: "mt-3 text-right" },
        [
          _c(
            "a-space",
            [
              _c("a-button", { on: { click: _vm.handleBack } }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_back")) + " ")
              ]),
              _vm.$can("create", "inventory-receive") && _vm.isModeCreate
                ? _c(
                    "a-button",
                    {
                      attrs: { loading: _vm.loading.draft },
                      on: {
                        click: function($event) {
                          return _vm.validateForm("draft")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_save_as_draft")) + " ")]
                  )
                : _vm._e(),
              _vm.$can("update", "inventory-receive") && _vm.isModeEdit
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading.update },
                      on: {
                        click: function($event) {
                          return _vm.validateForm("update")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_update")) + " ")]
                  )
                : _vm._e(),
              _vm.$can("read", "inventory-receive") && _vm.isModeEdit
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading.print },
                      on: { click: _vm.handlePrint }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_print")) + " ")]
                  )
                : _vm._e(),
              _vm.$can("create", "inventory-receive") ||
              _vm.$can("update", "inventory-receive")
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading.submit },
                      on: {
                        click: function($event) {
                          return _vm.validateForm("submit")
                        }
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_submit")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }